import { Flex, Spin } from 'antd';
import React from 'react';

import { Text, useTheme, utils } from '@desygner/ui-common-components';

import { StyledLoadingViewWrapper } from '../AuthModal.styles';
import { LoadingViewLabelsT, LoadingViewPropsT } from '../AuthModal.types';

export const LoadingView = ({ ...props }: LoadingViewPropsT) => {
  const { ...labels } = props.labels as LoadingViewLabelsT;
  const theme = useTheme();

  return (
    <StyledLoadingViewWrapper justify="center" align="center">
      <Flex vertical gap={utils.rem(theme.Spacing.Size.Small)}>
        <Spin />
        <Text size="Body" color={theme.Color.Brand.Primary}>
          {labels.loadingMessage}
        </Text>
      </Flex>
    </StyledLoadingViewWrapper>
  );
};
